import React from 'react'
import { inject, observer } from 'mobx-react'
import ButtonList from '../../../generic/ButtonList'
import { Box } from '../../../generic/Box'
import Title from '../../../generic/Title'

const BranchList = inject('nfsStore')(observer(props => {
  const { nfsStore } = props
  const buttons = nfsStore.state.branches.map(data => {
    return {
      text: data.name,
      onClick: () => {
        nfsStore.setBranch(data.id)
        nfsStore.fetchFiles()
      },
      styleClass: 'is-info',
      isActive: data.id === nfsStore.state.branch
    }
  })
  return (
    <Box>
      <Title>Filiais</Title>
      <ButtonList buttons={buttons} />
    </Box>
  )
}))

export default BranchList



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4nfs/NFSBranchList.js